import React from "react";

function DefaultPrompt({ onClick }: { onClick: (data: string) => void }) {
  const prompt = [
    {
      title: "Quelles sont les approches de gestion de projet ?",
      description:
        "Description des différentes approches ou systèmes de pratiques les plus populaires en gestion de projet.",
      prompt:
        "Présentez les principales méthodes en gestion de projet (agiles, classiques, hybrides), avec des exemples pour chaque méthode (Scrum, Kanban, Waterfall, Prince2, etc.). Expliquez brièvement les avantages et les contextes d'utilisation pour chaque méthode. Terminez en suggérant des critères pour choisir la méthode la plus adaptée selon le type de projet (exemple : flexibilité, clarté des besoins, structure).",
    },
    {
      title: "Stratégies de gestion des risques",
      description:
        "Les stratégies d'identification et d'évaluation des risques inhérents à un projet, permettant de mitiger et gérer leur impact sur ce dernier.",
      prompt:
        "Comment élaborer une stratégie efficace de gestion des risques dans un projet? Décrivez un processus structuré qui inclut l’identification, l’évaluation, et la priorisation des risques, ainsi que les principales stratégies de réponse telles que l’élimination, l’atténuation, le transfert, ou l’acceptation des risques. Expliquez également comment intégrer ces étapes dans un plan de gestion des risques et assurer un suivi continu tout au long du cycle de vie du projet.",
    },
    {
      title: "Comment définir les indicateurs de performance d’un projet",
      description:
        "Le suivi de projet par des KPI (indicateurs de performance) est essentiel pour évaluer l'avancement, la performance et la qualité des actions entreprises.",
      prompt:
        "Comment définir les indicateurs clés de performance (KPI) d’un projet ? Expliquez comment identifier les objectifs du projet et sélectionner des KPI adaptés aux différentes catégories telles que les coûts, les délais, la productivité, les risques et la satisfaction des parties prenantes. Précisez également comment organiser leur suivi dans un tableau de bord et adapter ces indicateurs en fonction de l’évolution du projet.",
    },
    {
      title:
        "Comment recadrer un projet qui part en dérive en termes de délais",
      description:
        "Un projet qui dérape est un projet qui risque de ne pas atteindre les résultats escomptés. Recadrer consiste à mettre en place une stratégie pour remettre sur les rails, un projet qui dérape.",
      prompt:
        "Comment recadrer un projet en dérive sur les délais ? Proposez une approche en 4 étapes : identifier les problèmes à l’origine des écarts, réaliser un état des lieux des travaux et ressources, définir une stratégie adaptée pour rattraper les délais, et enfin mettre en œuvre un plan d’action détaillé avec un suivi rigoureux. Fournissez une réponse claire et pratique.",
    },
  ];
  return (
    <div className="flex items-center h-56 gap-6 overflow-x-auto w-full whitespace-pre-wrap scrollbar-hide">
    {prompt.map((item, index) => (
      <div
        key={index}
        className="p-4 flex flex-col h-52 border shadow dark:text-white dark:border-gray-700/30 dark:bg-gray-700/40 dark:shadow-lg rounded-2xl cursor-pointer hover:shadow-xl dark:hover:shadow-2xl transition-shadow duration-300"
        onClick={() => onClick(item.prompt)}
      >
        <div className="flex items-center mb-2">
          <h3 className="font-bold">{item.title}</h3>
        </div>
        <div className="w-80">{item.description}</div>
      </div>
    ))}
  </div>
  );
}

export default DefaultPrompt;
